import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../contexts/ThemeContext';
import { formatDateTime } from '../../../config/appConfig';
import { useApprovals, type Approval } from '../../approvals/useData';
import GenericListWidget from './GenericListWidget';

const ApprovalsRecentPending: React.FC<{
  limit?: number;
  embedded?: boolean;
  settings?: Record<string, unknown>;
}> = ({ limit = 5, embedded, settings }) => {
  const navigate = useNavigate();
  const { colors } = useTheme();
  const effectiveLimit = typeof settings?.limit === 'number' ? settings.limit : limit;
  const { data, isLoading } = useApprovals('mine', 1, '', { status: 'PENDING' });

  return (
    <GenericListWidget<Approval>
      title="Approvals · Pending"
      viewAllPath="/approvals"
      data={data ?? []}
      isLoading={isLoading}
      limit={effectiveLimit}
      emptyMessage="No pending approvals"
      getItemKey={(item) => item.id}
      embedded={embedded}
      renderItem={(approval) => (
        <div
          role="button"
          tabIndex={0}
          onClick={() => navigate(`/approvals/${approval.id}`)}
          onKeyDown={(e) => e.key === 'Enter' && navigate(`/approvals/${approval.id}`)}
          className="flex items-center justify-between gap-3 p-2 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/40 cursor-pointer"
        >
          <div className="min-w-0">
            <p className={`text-sm font-medium truncate ${colors.text}`}>{approval.title}</p>
            <p className={`text-xs ${colors.textMuted}`}>
              {approval.approvalType?.name || 'Approval'}
            </p>
          </div>
          <span className={`text-xs whitespace-nowrap ${colors.textMuted}`}>
            {formatDateTime(approval.submittedAt || approval.createdAt)}
          </span>
        </div>
      )}
    />
  );
};

export default ApprovalsRecentPending;
